import React from 'react';
import { Box, Button, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useViewTenant } from '../contexts/ViewTenantContext';
import { useNavigate } from 'react-router-dom';

const BUTTON_ALLOWED_ROUTES = [
  '/tenant-domains',
  '/api-request-history',
  '/product-management',
  '/inspection-item-list',
];

const DYNAMIC_ALLOWED_ROUTES = [
  /^\/[^/]+$/, // Matches /:tenant
  /^\/user\/[^/]+\/[^/]+$/, // Matches /user/:tenant/:userTenant
];

interface ViewTenantModeButtonProps {
  position?: {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
  };
}

const ViewTenantModeButton: React.FC<ViewTenantModeButtonProps> = ({
  position = { top: '100px', right: '50px' }
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isViewTenantMode, exitViewTenantMode } = useViewTenant();
  const buttonBgColor = useColorModeValue('white', 'gray.800');
  
  const isAllowedRoute = () => {
    const currentPath = window.location.pathname;
    
    if (BUTTON_ALLOWED_ROUTES.some(route => currentPath.startsWith(route))) {
      return true;
    }
    
    return DYNAMIC_ALLOWED_ROUTES.some(pattern => pattern.test(currentPath));
  };

  const handleExitViewMode = () => {
    exitViewTenantMode();
    navigate('/tenant-management');
  };
  
  if (!isViewTenantMode || !isAllowedRoute()) {
    return null;
  }
  
  return (
    <Box
      position="fixed"
      top={position.top}
      bottom={position.bottom}
      left={position.left}
      right={position.right}
      zIndex={10}
      bg={buttonBgColor}
      shadow="lg"
      borderRadius="md"
      p={1}
    >
      <Button
        colorScheme="blue"
        onClick={handleExitViewMode}
        size="md"
      >
        {t('common.exit_view_mode')}
      </Button>
    </Box>
  );
};

export default ViewTenantModeButton; 